import { render, staticRenderFns } from "./Click-To-Call.vue?vue&type=template&id=5b209d50&"
import script from "./Click-To-Call.vue?vue&type=script&lang=js&"
export * from "./Click-To-Call.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/surex/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b209d50')) {
      api.createRecord('5b209d50', component.options)
    } else {
      api.reload('5b209d50', component.options)
    }
    module.hot.accept("./Click-To-Call.vue?vue&type=template&id=5b209d50&", function () {
      api.rerender('5b209d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Click-To-Call.vue"
export default component.exports